import { selectCar } from './selectCar';

export const selectCity = (state) => selectCar(state).city;
